import { render, staticRenderFns } from "./christchurchCalling.vue?vue&type=template&id=4ffc833d&scoped=true&"
import script from "./christchurchCalling.vue?vue&type=script&lang=js&"
export * from "./christchurchCalling.vue?vue&type=script&lang=js&"
import style0 from "./christchurchCalling.vue?vue&type=style&index=0&id=4ffc833d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc833d",
  null
  
)

export default component.exports